<template>
  <div v-if="input">
    <Dialog
      :visible="active"
      :closable="false"
      :modal="true"
      :style="{ maxWidth: '90%', width: 'auto', minWidth: '600' }"
    >
      <template #header>
        <div class="p-d-block w100">
          <span class="p-dialog-title">{{ $t("scores") }}</span>
          <Button @click="save" class="floatRight">{{ $t("Button.save-all-and-close") }}</Button>
          <Button @click="editAll" class="p-button-text floatRight">{{ $t("Button.edit-all") }}</Button>
        </div>
      </template>
      <div>
        <div class="p-my-3">
          <DataTable
            :scrollable="true"
            :value="input"
            class="p-datatable-sm p-datatable-striped whiteBg"
            editMode="row"
            dataKey="id"
            :editingRows.sync="editingRows"
            @row-edit-save="onRowEditSave"
          >
            <Column field="date" :header="$t('scoreHeaders.date')"></Column>
            <Column field="weekday" :header="$t('scoreHeaders.weekday')"></Column>
            <Column field="visitor.name" :header="$t('scoreHeaders.visitor')"></Column>
            <Column field="home.name" :header="$t('scoreHeaders.home')"></Column>

            <Column field="visitor_score" :header="$t('scoreHeaders.visitorScore')">
              <template #editor="slotProps">
                <InputText
                  v-model="slotProps.data[slotProps.column.field]"
                  autofocus
                  @keypress="isNumber"
                  style="width:30%"
                />
              </template>
            </Column>

            <Column field="home_score" :header="$t('scoreHeaders.homeScore')">
              <template #editor="slotProps">
                <InputText v-model="slotProps.data[slotProps.column.field]" @keypress="isNumber" style="width:30%" />
              </template>
            </Column>

            <Column field="overtime" :header="$t('scoreHeaders.overtime')">
              <template #body="slotProps">
                {{ slotProps.data.overtime ? $t("yes") : $t("no") }}
              </template>
              <template #editor="slotProps">
                <div class="p-text-center">
                  <Checkbox v-model="slotProps.data[slotProps.column.field]" :binary="true" />
                </div>
              </template>
            </Column>

            <Column :rowEditor="true" style="width:10%; min-width:8rem" bodyStyle="text-align:center"></Column>
          </DataTable>
        </div>

        <div class="p-my-3">
          <Button @click="save">{{ $t("Button.save") }}</Button>
          <Button :label="$t('Button.cancel')" @click="emitHide" class="p-button-text"></Button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import api from "@/api";

export default {
  components: { DataTable, Column },
  props: {
    input: {
      type: Array,
      required: false,
    },
    active: {
      type: Boolean,
      required: true,
    },
    schedule: {
      type: Object,
      required: true,
    },
    refreshSchedule: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      editingRows: [],
      updateError: false,
      error: "",
    };
  },
  methods: {
    emitHide() {
      this.$emit("hide");
    },
    onRowEditSave(event) {
      let { data, index } = event;
      this.input[index] = data;
      this.input[index].game.visitor_score = data.visitor_score;
      this.input[index].game.home_score = data.home_score;
      this.input[index].game.overtime = data.overtime;
    },
    editAll() {
      this.editingRows = [...this.input];
    },
    isNumber(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      } else {
        return true;
      }
    },
    save() {
      this.input.forEach((item, index) => {
        this.input[index].game.visitor_score = this.input[index].visitor_score;
        this.input[index].game.home_score = this.input[index].home_score;
        this.input[index].game.overtime = this.input[index].overtime;
      });

      const games = this.input.map(item => {
        return {
          id: item.game.id,
          home_score: item.game.home_score,
          visitor_score: item.game.visitor_score,
          overtime: item.game.overtime,
        };
      });

      this.updateGames(games);

      if (!this.updateError) {
        this.makeToast("success", this.$t("Toast.success"));
      } else {
        this.makeToast("error", this.error);
      }

      this.emitHide();
    },
    updateGames(games) {
      api
        .updateGames(games)
        .then(() => {
          if (this.schedule.config.is_tournament) {
            this.refreshSchedule();
          }
        })
        .catch(e => {
          this.error = e;
          this.updateError = true;
          console.log(e);
        });
    },
  },
};
</script>

<style scoped lang="scss"></style>
